import type { Attachment } from '@medplum/fhirtypes'
import { IconFile } from '@tabler/icons-react'
import type { JSX } from 'react'
import { AttachmentCardLayout } from '#src/components/attachments/AttachmentCardLayout.tsx'

interface AttachmentFallbackDisplayProps {
  attachment: Attachment
  onTitleChange?: (title: string) => void
}

export function AttachmentFallbackDisplay({
  attachment,
  onTitleChange,
}: AttachmentFallbackDisplayProps): JSX.Element {
  return (
    <AttachmentCardLayout
      attachment={attachment}
      title={attachment.title || 'Document'}
      icon={<IconFile className="h-4 w-4" />}
      onTitleChange={onTitleChange}
    />
  )
}
